import { GUID, Param } from "app/brightserve/brightserve.module";
import { Person } from "./person";

export class Medication {
    Id: GUID;
    Name: string;
    Code: string;
    Type: Param;
    Patient: Person;

    constructor(init?: Partial<Medication>) {
        Object.assign(this, init);

        if (init && init.Type) {
            this.Type = new Param(init.Type);
        } else {
            this.Type = null;
        };

        if (init && init.Patient) {
            this.Patient = new Person(init.Patient);
        } else {
            this.Patient = null;
        };
    }

    static BlankMedication() {
        var medication = new Medication();
        medication.Id = GUID.newGuid();
        medication.Type = new Param();
        return medication;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/medication.ts